module.exports = __webpack_public_path__ + "img/toks.a33c450c.webp";